module.exports = __webpack_public_path__ + "media/navigation/user-account-1533627e.svg";